import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckVirtualGenomeExistsQueryVariables = Types.Exact<{
  genomeIds: Array<Types.InputMaybe<Types.Scalars['Long']['input']>> | Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type CheckVirtualGenomeExistsQuery = { getVirtualGenomesForComponents: Array<{ id: number, name: string | null, description: string | null, userGroups: Array<{ id: number } | null> | null } | null> | null };


export const CheckVirtualGenomeExistsDocument = gql`
    query checkVirtualGenomeExists($genomeIds: [Long]!) {
  getVirtualGenomesForComponents(genomeIds: $genomeIds) {
    id
    name
    description
    userGroups {
      id
    }
  }
}
    `;

/**
 * __useCheckVirtualGenomeExistsQuery__
 *
 * To run a query within a React component, call `useCheckVirtualGenomeExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckVirtualGenomeExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckVirtualGenomeExistsQuery({
 *   variables: {
 *      genomeIds: // value for 'genomeIds'
 *   },
 * });
 */
export function useCheckVirtualGenomeExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables> & ({ variables: CheckVirtualGenomeExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables>(CheckVirtualGenomeExistsDocument, options);
      }
export function useCheckVirtualGenomeExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables>(CheckVirtualGenomeExistsDocument, options);
        }
export function useCheckVirtualGenomeExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables>(CheckVirtualGenomeExistsDocument, options);
        }
export type CheckVirtualGenomeExistsQueryHookResult = ReturnType<typeof useCheckVirtualGenomeExistsQuery>;
export type CheckVirtualGenomeExistsLazyQueryHookResult = ReturnType<typeof useCheckVirtualGenomeExistsLazyQuery>;
export type CheckVirtualGenomeExistsSuspenseQueryHookResult = ReturnType<typeof useCheckVirtualGenomeExistsSuspenseQuery>;
export type CheckVirtualGenomeExistsQueryResult = Apollo.QueryResult<CheckVirtualGenomeExistsQuery, CheckVirtualGenomeExistsQueryVariables>;